// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { WalletProvider } from "./components/WalletContext"; // ✅ Import it

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <WalletProvider> {/* ✅ Wrap your app here */}
        <App />
      </WalletProvider>
    </HashRouter>
  </React.StrictMode>
);
